import Card, { CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import { usePageTitle } from '../../../hooks/shared';

export default function VoterRegistration() {
  usePageTitle('Voter Registration');
  return (
    <div className="bg-neutral-50 min-h-screen py-8">
      <div className="container-custom">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-serif font-bold mb-2">Voter Registration</h1>
          <p className="text-neutral-600">Complete or update your voter registration</p>
        </div>

        <Card patrioticShadow>
          <CardHeader>
            <CardTitle>Registration Form</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-neutral-600 mb-4">
              Complete your voter registration forms online with state-specific requirements and
              validations.
            </p>
            <p className="text-sm text-neutral-500">
              This will be a multi-step wizard with PDF generation capabilities.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
